import './stylesheets/VideoPlayer.css';
import ExitButton from './ExitButton';
import ReactPlayer from 'react-player';
import React, { useRef, useState } from 'react';

function VideoPlayer(props) {
    const [isPlayerVisible, setPlayerVisibility] = useState(false);
    const [playing, setPlaying] = useState(false);
    const playerRef = useRef(null); // Create a ref using useRef
    const play = () => setPlaying(true)
    const pause = () => setPlaying(false)
    const handleExit = () => {
        const player =  document.getElementById('VideoPlayer') || 
                        document.getElementById('VideoPlayer-Active');
        if (player) {
            player.id = player.id === 'VideoPlayer' ? 'VideoPlayer-Active' : 'VideoPlayer';
            console.log(props.nowPlaying);
        } else {
            console.log('error, no video player');
        }
        if (playerRef.current) {
            pause();
        } else {
            console.log('not current');
        }
        setPlayerVisibility(false);
    }
    const handlePlay = () => {
        setPlayerVisibility(true);
    };
    return (
        <div id="VideoPlayer">
            <ExitButton onExit={handleExit} />
            <ReactPlayer
                ref={playerRef}
                url={props.nowPlaying.videoUrl}
                controls={true}
                width="100%"
                height="100%"
                playing={playing}
                onPlay={play}
                onPause={pause}
            />
            {/* <div>
                testing
            </div>
            <div>
                {props.nowPlaying.title}
            </div>
            <div>
                {props.nowPlaying.description}
            </div> */}
        </div>
    );
}

export default VideoPlayer;
